import styled from "styled-components";

export const MarketingWrapper = styled.div`
  width: 100%;
  height: 100vh;
  overflow: auto;
`;

export const MarketingBanner = styled.div`
  position: relative;

  > img {
    width: 100%;
    height: 277px;
    object-fit: cover;
  }

  > .text {
    height: 82px;
    position: absolute;
    bottom: 12px;
    left: 50%;
    transform: translateX(-50%);
    color: #fff;
    display: flex;
    flex-direction: column;
    gap: 4px;
    align-items: center;
    font-weight: 700;
    font-size: 20px;
    text-align: center;
    line-height: 140%;

    > .border {
      font-weight: 600;
      font-size: 16px;
      line-height: 140%;
    }
  }
`;

export const MarketingContentWrapper = styled.div`
  padding: 20px 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const MarketingItemWrapper = styled.div`
  width: 100%;
  border-radius: 8px;
  padding: 16px;
  box-shadow: 0px 0px 12px 0px #00000033;
`;

export const MarketingItemTitle = styled.div`
  display: flex;
  gap: 2px;
  align-items: flex-end;
  font-weight: 700;
  font-size: 18px;
  color: var(--Black-400, #444444);

  > span {
    font-weight: 600;
    font-size: 14px;
    color: #808080;
  }
`;

export const MarketingInfo = styled.div`
  margin-top: 8px;
  margin-left: 6px;

  > div {
    font-weight: 500;
    font-size: 14px;
    color: var(--Black-300, #808080);
    line-height: 20px;
  }
`;

export const MarketingButton = styled.div`
  margin-top: 12px;
  background: #1f9f81;
  width: 100%;
  height: 44px;
  border-radius: 8px;
  font-weight: 600;
  font-size: 15px;
  line-height: 44px;
  text-align: center;
  color: #fff;
`;

export const MarketingRequestWrapper = styled.div`
  width: calc(100% - 52px);
  top: 50%;
  left: 50%;
  border-radius: 12px;
  background: #ffffff;
  position: absolute;
  z-index: 1000;
  transform: translate(-50%, -50%);
  padding: 30px 15px 24px;
`;

export const MarketingRequestHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;

  > .title {
    font-weight: 600;
    font-size: 18px;
    color: var(--Black-500, #202020);
  }
`;

export const MarketingRequestInputWrapper = styled.div`
  margin-top: 12px;
  display: flex;
  flex-direction: column;
  gap: 8px;

  > .name {
    font-weight: 500;
    font-size: 16px;
    line-height: 140%;
    color: var(--Black-500, #202020);
  }

  > input {
    width: 100%;
    height: 37px;
    border-radius: 4px;
    padding: 10px 12px;
    border: 1px solid var(--Black-100, #f0f0f0);
    outline: none;
  }

  > textarea {
    width: 100%;
    height: 84px;
    border-radius: 4px;
    padding: 10px 12px;
    border: 1px solid var(--Black-100, #f0f0f0);
    outline: none;
    resize: none;
  }
`;

export const MarketingRequestDateWrapper = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  font-family: Pretendard;
  font-weight: 500;
  font-size: 16px;
  line-height: 140%;
`;
export const MarketingRequestDateBox = styled.div`
  display: flex;
  gap: 3px;
`;

export const MarketingRequestButton = styled.div<{ on: boolean }>`
  margin-top: 24px;
  width: 100%;
  height: 48px;
  gap: 10px;
  border-radius: 8px;
  background: ${(p) => (p.on ? "#6436E7" : "#d9d9d9")};
  font-weight: 600;
  font-size: 15px;
  line-height: 48px;
  text-align: center;
  color: #ffffff;
`;
